import React from 'react';
import { useWolfTracsState } from '../../hooks/redux/useWolfTracsState';
import { EnrollmentPackageId, PersonId } from '../../types/api/primaryKeys/PrimaryKey';
import { PackageType } from '../../types/enums/PackageType';
import { ReactFC } from '../../types/react/ReactFC';
import { LoadingBlock } from '../LoadingBlock';
import { EmployeeDependentDetail } from '.'; 
import { EmployeeDependentDetailNew } from './EmployeeDependentDetailNew';
import { useNumberIdsFromRoute } from '../../hooks/routing/useNumberIdsFromRoute';

interface Props {
    packageId: EnrollmentPackageId;
}

export const EmployeeDependentDetailLanding: ReactFC<Props> = ({ packageId }) => {
    const { data: activePackage } = useWolfTracsState(s => s.packages.activePackage);

    const { dependentid: dependentPersonId } = useNumberIdsFromRoute() as { dependentid: PersonId };

    if (activePackage === null) {
        return <LoadingBlock />;
    }

    // This is not ideal. In future, all groups should be switched over. For now, public enrollment == new form.
    if (activePackage.packageTypeId === PackageType.PublicEnrollment) {
        return (
            <EmployeeDependentDetailNew 
                packageId={packageId} 
                dependentPersonId={dependentPersonId} 
                employeePersonId={activePackage.personId}
                groupId={activePackage.groupId}
            />
        );
    } else {
        return (
            <EmployeeDependentDetail packageId={packageId} />
        );
    }
};